export default function CategoryHeader({ title, image, className }) {
  return (
    <header
      className={`${className} bg-cover bg-center h-64 flex justify-center items-center text-white`}
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-semibold">
        {title}
      </h1>
    </header>
  )
}
